/**
 * File for logic corresponding to video playlist component, which is comprised
 * of a single video player and a carousel, grid, or other list of video
 * thumbnails that are played in the one player.
 */
// eslint-disable-next-line max-len
import VideoPlaylistFactory from '../video-playlist-factory/video-playlist-factory';

export default class VideoPlaylist extends VideoPlaylistFactory {
  /**
   * Whether this playlist should display as a carousel.
   *
   * @type {Boolean}
   */
  isCarousel = true;

  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    const { articles, articleContent } = this.children;
    const { context } = this.element.dataset;

    this.isCarousel = this.element.classList.contains(
      'video-playlist--carousel',
    );

    this.setCarouselArrowPosition = this.setCarouselArrowPosition.bind(this);

    // Maybe initialize Slick.
    if (this.isCarousel) {
      if ('carousel_sidebar--video' === context) {
        $(articleContent).slick(this.options.slickOptionsSidebar);
      } else {
        $(articleContent)
          .on('setPosition', this.setCarouselArrowPosition)
          .slick(this.options.slickOptions);
      }
    }

    /**
     * If there's only one video, suppress the carousel instead (suppress,
     * rather than remove, because we still need to access the Anvato data
     * attribute on the video).
     */
    if (2 > articles.length && this.isCarousel) {
      articleContent.style.display = 'none';
    }
  }

  /**
   * Set the player to a new video.
   *
   * @extends VideoPlaylistFactory.setCurrentVideo
   * @param {Object} videoJson  Anvato player configuration JSON.
   * @param {Number} videoIndex Index of video in the playlist.
   * @param {Boolean} isVideoHeroItem if the video is in a hero layout.
   */
  setCurrentVideo(videoJson, videoIndex, isVideoHeroItem) {
    super.setCurrentVideo(videoJson, videoIndex, isVideoHeroItem);

    const { articleContent } = this.children;
    const $articleContent = $(articleContent);

    // Maybe update the Slick instance.
    if (this.isCarousel) {
      $articleContent.slick('slickGoTo', videoIndex);
    }
  }
}
